import React, { Component } from 'react'
import QuickActions from './QuickActions'

class DashboardBottomWrapper extends Component {
  render() {
    return (
      <div className={'dashboardQuickActionsRow'}>
        <QuickActions />
      </div>
    )
  }
}

export default DashboardBottomWrapper